import { takeLatest, put, call } from 'redux-saga/effects';
import * as ReportActions from './action';
import fileSaver from 'file-saver';
import { REPORT, CORE_API } from '../../config';
import request from '../../components/Utils/httpHelper';
import { HTTP_HEADERS,HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';

export function* fetchReport(action) {
    let requestURL = `${REPORT}/computedreport/${action.data}/details`;
    try {
        const result = yield call(request, requestURL, { headers: HTTP_HEADERS });
        yield put(ReportActions.fetchReportDetailsSuccess(result.data))
    } catch (err) {
        yield put(ReportActions.fetchReportDetailsFailure(err))
    }
}
export function* fetchReportDetails() {
    yield takeLatest(ReportActions.FETCH_REPORT_DETAILS, fetchReport);
}

export function* fetchPaymentScore(action) {
    let requestURL = `${CORE_API}/paymentrisk/view/${action.data}`;
    try {
        const result = yield call(request, requestURL, { headers: HTTP_HEADERS });
        yield put(ReportActions.fetchPaymentScoreSuccess(result.data))
    } catch (err) {
        yield put(ReportActions.fetchPaymentScoreFailure(err.response))
    }
}
export function* fetchPaymentScoreDetails() {
    yield takeLatest(ReportActions.FETCH_PAYMENT_SCORE, fetchPaymentScore);
}

export function* fetchCUG(action) {
    let requestURL = `${CORE_API}/paymentrisk/cug/view/${action.data.counterpartyId}/${action.data.counterpartyType}`;
    try {
        const result = yield call(request, requestURL, { headers: HTTP_HEADERS });
        yield put(ReportActions.fetchCugScoreSuccess(result.data))
    } catch (err) {
        yield put(ReportActions.fetchCugScoreFailure(err.response))
    }
}
export function* fetchCugScoreDetails() {
    yield takeLatest(ReportActions.FETCH_CUG_SCORE, fetchCUG);
}

export function* fetchPaymentRisk(action) {
    let requestURL = `${CORE_API}/paymentrisk/fetch/riskgrades`;
    try {
        const result = yield call(request, requestURL, { headers: HTTP_HEADERS });
        yield put(ReportActions.fetchPaymentRiskgradeSuccess(result.data))
    } catch (err) {
        yield put(ReportActions.fetchPaymentRiskgradeFailure(err.response))
    }
}
export function* fetchPaymentRiskGrades() {
    yield takeLatest(ReportActions.FETCH_PAYMENT_RISKGRADES, fetchPaymentRisk);
}

export function* dataCheck(action) {
    let requestURL = `${CORE_API}/paymentrisk/dataexists/${action.data.counterpartyId}/${action.data.counterpartyType}`;
    try {
        const result = yield call(request, requestURL, { headers: HTTP_HEADERS });
        yield put(ReportActions.dataCheckSuccess(result.data))
    } catch (err) {
        yield put(ReportActions.dataCheckFailure(err.response))
    }
}
export function* reportDataCheck() {
    yield takeLatest(ReportActions.DATA_CHECK, dataCheck);
}

export function* fetchCounterpartyReportList(action) {
    let requestURL = `${REPORT}/case/counterpartyReports/${action.data.counterpartyId}/${action.data.counterpartyType}`;
    try {
        const data = yield call(request, requestURL, { headers: HTTP_HEADERS });
        yield put(ReportActions.fetchReportListResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(ReportActions.fetchReportListResponse( { ...err.response , status : "FAILURE"}))
    }
}
export function* fetchCounterpartyReports() {
    yield takeLatest(ReportActions.FETCH_REPORT_LIST_REQUEST, fetchCounterpartyReportList);
}

export function* caseSections(action) {
    let requestUrl = `${REPORT}/computedreport/metadata/${action.data}`;//	/computedreport/metadata/{computedreportid}
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ReportActions.sectionSuccess(listResult));
    } catch (err) {
        yield put(ReportActions.sectionFailure(err))
    }
}
export function* fetchSections() {
    yield takeLatest(ReportActions.GET_ALL_SECTIONS, caseSections);
}

export function* sectionPdf(action) {
    let requestUrl = `${REPORT}/computedsection/pdf/url/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ReportActions.showSectionPdfSuccess(listResult));
    } catch (err) {
        yield put(ReportActions.showSectionPdfFailure(err))
    }
}
export function* showSectionPdf() {
    yield takeLatest(ReportActions.SHOW_SECTION_PDF, sectionPdf);
}

export function* reportPdfDownload(action) {
    let requestUrl = `${REPORT}/computedreport/pdf/download/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  });
        var blob = new Blob([listResult.data],
            { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, action.name+'.pdf');
        yield put(ReportActions.downloadReportPdfSuccess(listResult));
    } catch (err) {
        yield put(ReportActions.downloadReportPdfFailure(err))
    }
}
export function* downloadReportPdf() {
    yield takeLatest(ReportActions.DOWNLOAD_REPORT_PDF, reportPdfDownload);
}
export function* updateBPRStatus(action) {
    let requestURL = `${REPORT}/case/updateBPRStatus/${action.data}`;
    try {
        const result = yield call(request, requestURL, { data: '', method: 'POST',headers: HTTP_HEADERS });
        yield put(ReportActions.updateBPRStatusSuccess(result.data))
    } catch (err) {
        yield put(ReportActions.updateBPRStatusFailure(err))
    }
}
export function* updateBPRStatusCheck() {
    yield takeLatest(ReportActions.BPR_STATUS, updateBPRStatus);
}